import React, { useState } from 'react';
import { func, string, bool, oneOfType } from 'prop-types';
import { validate as validator } from 'ui-validator';
import { PhoneNumberInput } from '@shared_modules/local-propulsion/components';
import { heapTrackErrors } from '@shared_modules/baui-heap-tracking';
import { Page } from '../../components';
import SecurityNotice from '../../components/SecurityNotice';
import validations from './phone-validations';

const Phone = ({
  phoneType: initialPhoneType,
  phoneSource,
  phone: initialPhone,
  saveValues,
  nextLocation,
  previousLocation,
}) => {
  const [phoneType, setPhoneType] = useState(initialPhoneType);
  const [phone, setPhone] = useState(initialPhone);
  const [validationErrors, setValidationErrors] = useState({});

  const handleInputChange = event => {
    const value = event.target.value;
    setPhone(value);
  };

  const handleBlur = () => {
    const errors = validator({ phone }, validations);
    setValidationErrors(errors);
  };

  const handlePhoneTypeChange = event => {
    const value = event.target.value;
    if (window.lcTracking) {
      window.lcTracking.trackCustomEvent({
        eventName: 'Phone Type in PI1',
        ACTION: 'Phone Type selected',
        MESSAGE: `Selected Phone Type in PI1 - ${value}`,
      });
    }

    setPhoneType(value);
  };

  const submit = e => {
    if (e) e.preventDefault();
    const errors = validator({ phone }, validations);
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      heapTrackErrors(errors);
    } else {
      saveValues({
        phone: {
          phoneType,
          phoneSource,
          phone,
        },
      });
      nextLocation();
    }
  };

  const getTitleHeader = () => {
    return {
      title: 'What’s your phone number?',
      header: 'If we have any questions, we’ll be sure to reach out.',
    };
  };

  const { title, header } = getTitleHeader();

  return (
    <Page title={title} header={header} name="phone" goBack={previousLocation} submitHandler={submit}>
      <PhoneNumberInput
        autoFocus={!phone}
        defaultValue={phone}
        disabled={false}
        label="Phone Number"
        name="phone"
        onChange={handleInputChange}
        onBlur={handleBlur}
        onPhoneTypeChange={handlePhoneTypeChange}
        phoneType={phoneType}
        validationErrors={validationErrors}
        showType
      />
      <div style={{ marginTop: 16 }}>
        <SecurityNotice text="We know that your information is personal, so we use bank-level encryption at all times." />
      </div>
    </Page>
  );
};

Phone.propTypes = {
  phone: string,
  phoneType: string,
  phoneSource: string,
  saveValues: func.isRequired,
  previousLocation: func.isRequired,
  nextLocation: func.isRequired,
};

Phone.defaultProps = {
  phone: '',
  phoneType: 'MOBILE',
  phoneSource: 'SELFREPORTED',
};

export default Phone;

